export enum DeviceDiscount {
  STUDENT = 'student',
}

export enum InputVariant {
  LIGHT = 'light',
  BOLD = 'bold',
}
